export const jobTitlesSelector = state => state.jobTitles;
